module.exports = __webpack_public_path__ + "static/salesforce-96d328427a4cb1db490ff00d679ce039.svg";